export const essentialCookies = [
    {
        key: 'essential_cookie_manager',
        name: 'Gestionnaire de cookies essentiel',
        description: 'Ce cookie est utilisé pour gérer les cookies sur ce site web.',
        privacyPolicyUrl: '',
        cookies: []
    }
];

export const marketingCookies = [
    {
        key: 'marketing_google_analytics',
        name: 'Google Analytics',
        description: {
            en: 'Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.',
            de: 'Google Analytics ist ein Webanalysedienst von Google, der Website-Traffic erfasst und berichtet.',
            pt: 'Google Analytics é um serviço de análise da web oferecido pela Google que rastreia e relata o tráfego do site.'
        },
        privacyPolicyUrl: {
            en: 'https://policies.google.com/privacy',
            de: 'https://policies.google.com/privacy?hl=de',
            it: 'https://policies.google.com/privacy?hl=it',
            pt: 'https://policies.google.com/privacy?hl=pt'
        },
        cookies: [
            {
                name: '_ga',
                description: 'This cookie is used to distinguish users.',
                duration: '2 years'
            }
        ]
    }
];

export const functionalCookies = [
    {
        key: 'functional_google_analytics',
        name: 'Google Analytics',
        description: 'TEST : Google Analytics est un service d\'analyse Web proposé par Google qui suit et rapporte le trafic du site Web.',
        privacyPolicyUrl: 'https://policies.google.com/privacy',
        cookies: [
            {
                name: '_ga',
                description: 'This cookie is used to distinguish users.',
                duration: '2 years',
            },
            {
                name: '_gid',
                description: 'This cookie is used to distinguish users.',
                duration: '24 hours',
            },
            {
                name: '_gat',
                description: 'This cookie is used to throttle request rate.',
                duration: '1 minute',
            },
            {
                name: '_gat_gtag_UA_XXXXXXXXX_1',
                description: 'This cookie is used to throttle request rate.',
                duration: '1 minute',
            },
            {
                name: 'AMP_TOKEN',
                description: 'This cookie is used to throttle request rate.',
                duration: '1 minute',
            }
        ]
    },
    {
        key: 'functional_google_tag_manager',
        name: 'Google Tag Manager',
        description: 'Google Tag Manager is a tag management system that allows you to quickly and easily update tags and code snippets on your website.',
        privacyPolicyUrl: 'https://policies.google.com/privacy',
        cookies: [
            {
                name: '_ga',
                description: 'This cookie is used to distinguish users.',
                duration: '2 years',
            },
            {
                name: '_gid',
                description: 'This cookie is used to distinguish users.',
                duration: '24 hours',
            }
        ]
    },
    {
        key: 'functional_google_maps',
        name: 'Google Maps',
        description: 'Google Maps is a web mapping service developed by Google.',
        privacyPolicyUrl: 'https://policies.google.com/privacy',
        cookies: []
    }
];

export const otherTools = [
    {
        key: 'functional_performance',
        name: 'Performance',
        description: 'Les cookies de performance nous permettent d’analyser le fonctionnement de notre plateforme, afin de mieux comprendre l’usage que vous faites de nos services de recrutement et de gestion des talents. Ces données nous aident à améliorer votre expérience utilisateur.',
        privacyPolicyUrl: '',
        cookies: [
            {
                name: '_act',
                description: 'This cookie is used to distinguish users.',
                duration: '2 years',
            }
        ]
    },
    {
        key: 'functional_publicite',
        name: 'Publicité',
        description: 'Les cookies publicitaires sont utilisés pour vous proposer des offres d’emploi ou des services RH personnalisés, en fonction de votre navigation antérieure sur la plateforme. Ils nous permettent également de mesurer l’efficacité de nos campagnes de communication.',
        privacyPolicyUrl: '',
        cookies: []
    }
];

export const fullFrenchLang = {
    language: 'Français',
    title: 'Nous apprécions votre vie privée',
    text: 'Nous et nos partenaires utilisons des technologies telles que les cookies ou le ciblage et traitons des données personnelles telles que l\'adresse IP ou les informations du navigateur pour personnaliser les publicités que nous affichons. Ces technologies peuvent accéder à votre appareil et nous aider à vous montrer des publicités plus pertinentes et à améliorer votre expérience sur notre site. Nous utilisons également ces technologies pour mesurer les résultats ou mieux cibler notre contenu web. Parce que nous valorisons votre vie privée, nous vous demandons par la présente votre consentement pour utiliser les technologies suivantes.',
    right_bottom: '',
    left_bottom: '',
    right_top: '',
    left_top: '',
    privacy_text: 'Politique de confidentialité',
    imprint_text: 'Mentions légales',
    privacy_settings_text: 'Paramètres de confidentialité',
    privacy_settings_title: 'Paramètres de confidentialité',
    privacy_settings_title_text: 'Cet outil vous aide à sélectionner et désactiver divers cookies, traqueurs et outils d\'analyse utilisés sur ce site.',
    //functional_title: "Fonctionnel",
    //functional_description: 'Ces cookies nous permettent d\'analyser l\'utilisation du site afin que nous puissions mesurer et améliorer ses performances.',
    functional_title: "Marketing",
    functional_description: 'Les cookies marketing sont généralement utilisés pour vous montrer des publicités qui correspondent à vos intérêts. Lorsque vous visitez un autre site, le cookie de votre navigateur est reconnu et des publicités sélectionnées vous sont affichées en fonction des informations stockées dans ce cookie (art. 6 par. 1 p. 1 a) RGPD).',
    marketing_title: "Marketing",
    marketing_description: 'Les cookies marketing sont généralement utilisés pour vous montrer des publicités qui correspondent à vos intérêts. Lorsque vous visitez un autre site, le cookie de votre navigateur est reconnu et des publicités sélectionnées vous sont affichées en fonction des informations stockées dans ce cookie (art. 6 par. 1 p. 1 a) RGPD).',
    essential_title: "Essentiel",
    essential_description: 'Ces cookies sont nécessaires pour les fonctions de base du site.',
    other_title: "Autre",
    other_description: 'Au sein de notre organisation, nous utilisons d\'autres outils pour le traitement des données. Ceux-ci sont également listés ici à titre informatif. Cependant, les données ne sont collectées qu\'après une certaine interaction, par exemple, lorsque vous acceptez une démonstration. Si vous souhaitez vous opposer au traitement des données par ces processeurs, veuillez nous contacter.',
    save_text: 'Enregistrer',
    accept_text: 'Accepter et fermer',
    decline_text: 'Continuer sans accepter',
    choose_language_text: 'Choisir la langue',
    back_text: 'Retour',
    cookie_name: 'Nom',
    cookie_description: 'Description',
    cookie_duration: 'Durée',
};